import React, { useContext, useState, useEffect } from 'react';
import { InputContext } from '../contexts/InputContext';
import authServices from '../services/authServices';
import MessageModal from '../container/MessageModal';
import { errorClassification } from '../errorHandler';
import { Navigate, Link, useSearchParams } from "react-router-dom";
import TextControl from '../container/customizedInputs/TextControl';
import SignInGoogleModal from '../container/SignInGoogleModal';

const Ingreso = () => {
  const [searchParams] = useSearchParams();

  const [authInformation, setAuthInformation] = useContext(InputContext)
  const [datosUsuario, setDatosUsuario] = useState({email: "", password: ""});

  // modal messages
  const [showModal, setShowModal] = useState(false);
  const [modalBody, setModalBody] = useState('');
  const handleShowModal = (message) => {setModalBody(message); setShowModal(true)};
  const handleCloseModal = () => { setShowModal(false); setModalBody('') };

  const signIn = async () => {
    try {
      const data = await authServices.signIn(datosUsuario);

      if(data.token){
        setAuthInformation({
          token: data.token,
          nombre: data.nombre,
          user_id: data.user_id,
          autenticado: true,
          rol: data.rol,
          email: data.email,
          es_empleado_tribunal: data.es_empleado_tribunal
        })
        localStorage.setItem('token', data.token);

        if(searchParams.get("redirect")){
          window.location.href = searchParams.get("redirect");
        }

      } else {
        setAuthInformation({token: undefined})
        localStorage.removeItem('token');
      }

      // setOferta(data);
      // setTotalPages(data.meta.total_pages);
    } catch (error) {
      const result = errorClassification(error)
      if(result.modal){
        handleShowModal(result.message)
      }
    }
  };

  const handleInput = (e) => {
    const { name, value } = e.target;
    setDatosUsuario({...datosUsuario,
        [name]: value
    })
  }

  const handleFormSubmit = (e) => {
    e.preventDefault()

    if (!datosUsuario.email || !datosUsuario.password) {
      alert('Por favor, ingrese su email y contraseña.');
      return;
    }
    signIn()
  }

  return (
    <div>
      {authInformation.autenticado === true && <Navigate to="/" />}
      {(authInformation.autenticado === false) && (

        <div className="row mx-5 align-items-center" >
          <div className="col">
            <form className='mb-3'>
              <h1 className="h3 mb-3 fw-normal">Ingreso</h1>
              {/* <pre>{JSON.stringify(authInformation, null, 2)}</pre> */}
              <TextControl
                className='mb-3'
                value={datosUsuario.email}
                name={'email'}
                handleInput={handleInput}
                type='email'
                label='Correo electrónico'
                />

              <TextControl
                value={datosUsuario.password}
                name={'password'}
                handleInput={handleInput}
                type='password'
                label='Clave'
                />

              <Link className="btn btn-link mb-3" to="/recuperoClave">Olvidaste la clave ?</Link>

              {/* <div className="form-check text-start my-3">
                <input className="form-check-input" type="checkbox" value="remember-me" id="flexCheckDefault" />
                <label className="form-check-label" htmlFor="flexCheckDefault">
                  Recordar email y clave
                </label>
              </div> */}
              <button className="btn btn-primary w-100 py-2" onClick={handleFormSubmit} type="submit">Entrar</button>
            </form>

            {/* USAR EN PRODUCCION CUANO EXISTA DOMINIO. GOOGLE NO ACEPTA IPS */}
            {/* <button className="btn btn-warning me-2" data-bs-toggle="modal" data-bs-target="#signInGoogle" >Ingresar con Google</button> */}

            <SignInGoogleModal />
          </div>
          <div className="col text-center">
            <div className='mb-3'>Aún no estás registrado ?</div>
            <Link className="btn btn-primary btn-lg" to={`/registro`} >Registrate</Link>
          </div>
        </div>
      )}

    <MessageModal
      showModal={showModal}
      handleCloseModal={handleCloseModal}
      modalBody={modalBody}
    />
    </div>
  );
};

export default Ingreso;